import type { NodeId, InputId, KeyframeMode } from 'web';
import type { FlowGraph } from '../FlowGraph';
import type { KeyframeData } from '@/types/node';

interface ResolvedImage {
  url: string;
  width: number;
  height: number;
  blobstore?: { id?: string };
}

export class KeyframeView {
  constructor(
    private graph: FlowGraph,
    private id: NodeId,
  ) {}

  getTimestampSeconds(): number {
    const data = this.graph.store.getNodeDataNullable<KeyframeData>(this.id);
    return data?.timestampSeconds ?? 0;
  }

  setTimestampSeconds(value: number, ongoing: boolean) {
    this.graph.wasmEdit((wasm) => wasm.setKeyframeTimestamp(this.id, value), ongoing);
  }

  setMode(mode: KeyframeMode) {
    this.graph.wasmEdit((wasm) => wasm.setKeyframeMode(this.id, mode), false);
  }

  evaluateImageInput(inputId: InputId): ResolvedImage | undefined {
    const evaluated = this.graph.evaluateInput(this.id, inputId);
    if (evaluated?.type !== 'image') return undefined;

    if (evaluated.value.type === 'file') {
      const { url, width, height, blobstore } = evaluated.value;
      return { url, width, height, blobstore };
    }

    const input = this.graph.getNodeInput(this.id, inputId);
    if (!input) return undefined;

    const rendered = this.graph.wasm.call((wasm) => wasm.exportNodeRender(input.nodeId, input.outputId));
    if (!rendered) return undefined;

    return { url: rendered.data, width: rendered.width, height: rendered.height };
  }
}
